<template>
    <div id="sfrecord">
        <loadings v-if="loading"></loadings>
        <template v-else>
            <headers title="发送记录"></headers>
            <div class="page_content">
                <table class="record_list" v-if="record_lists.length">
                    <thead>
                        <tr>
                            <td>发送日期</td>
                            <td>接收对象</td>
                            <td>接收人数</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="r in record_lists">
                            <td>{{ r.send_time }}</td>
                            <td>全部开通书法的学生</td>
                            <td>{{ r.num }}人</td>
                        </tr>
                    </tbody>
                </table>
                <noResouse text="暂无发送记录" v-else></noResouse>
            </div>
        </template>
    </div>
</template>
<script type="text/ecmascript-6">
    import loadings from "COMPONENTS/base/loadingS.vue";
    import headers from 'COMPONENTS/base/header.vue';
    import noResouse from 'COMPONENTS/noResouse.vue';
    export default {
        components: {
            loadings,headers,noResouse
        },
        data() {
            return {
                loading:true,
                record_lists:[],
            }
        },
        created() {
            this.getData();
        },
        methods: {
            getData(){
                this.$http.get(API_URL_HD_API + '/sf_train/log/').then(res => {
                    res = res.data;
                    if (res.response == 'ok') {
                        this.record_lists = res.data;
                    } else {
                        layer.tips(res.message);
                    }
                }).finally(()=>{this.loading = false});
            },
        },
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    #sfrecord{
        min-height: 100vh;
        background-color: #fff;
        .page_content{
            padding: 28px/$ppr 24px/$ppr;
            .record_list{
                border-radius: 10px/$ppr;
                border: 1px/$ppr solid #e7e7e7;
                border-collapse: separate;
                text-align: center;
                width: 100%;
                overflow: hidden;
                thead{
                    background-color: #ecf1f4;
                    tr{
                        font-size: 28px/$ppr;
                    }
                }
                tr{
                    height: 80px/$ppr;
                    font-size: 26px/$ppr;
                    td{
                        &:first-child,&:last-child{
                            width: 184px/$ppr;
                        }
                    }
                }
                tbody{
                    tr{
                        &:nth-of-type(even){
                            background-color: #f5f9ff;
                        }
                        td{
                            &:not(:last-child){
                                border-right: 1px/$ppr solid #e7e7e7;
                            }
                        }
                    }
                }
            }
        }
    }
</style>